import { useMemo } from "react"
import { ICardItem, ICardOwner } from "../types"

export const useCardGroups = (
  items: ICardItem[]
): Record<ICardOwner, ICardItem[]> =>
  useMemo(() => {
    const grouped: Record<ICardOwner, ICardItem[]> = {
      user: [],
      deck: [],
      opponent: [],
      active: [],
      archive: [],
      "removed-opponent": [],
      "removed-player": [],
      preview: [],
      "opponent-view": [],
      gold: []
    }

    for (const item of items) {
      grouped[item.owner].push(item)
    }

    Object.values(grouped).forEach((arr) =>
      arr.sort((a, b) => a.order - b.order)
    )
    grouped.archive.reverse()

    return grouped
  }, [items])
